export const GA_TRACKING_ID = process.env.GOOGLE_ANALYTICS;

type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[];
};

declare const window: WindowWithDataLayer;
// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, value }: { action: string; value: string }) => {
  window?.dataLayer?.push({
    event: action,
    [action]: value,
  });
};
// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const eventLogin = () => {
  window?.dataLayer?.push({
    event: 'login'
  });
};
// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const eventTrack = ({
  eventName,
  actionName,
  key1,
  value1,
  key2,
  value2,
}: {
  eventName: string;
  actionName: string;
  key1: string;
  value1: string;
  key2?: string;
  value2?: string;
}) => {
  const data = {
    event: eventName, // mandatory key
    event_data: {
      action: actionName,
      [key1]: value1,
      [key2!]: value2!,
    },
  };

  window?.dataLayer?.push(data);
};


export const perfEventTrack = ({
  eventName,
  pageOrigin
}: {
  eventName: string;
  pageOrigin: string;
}) => {
  const data = {
    event: eventName, // mandatory key
    page_origin: pageOrigin,
  };

  window?.dataLayer?.push(data);
};

export const userTrack = ({
  ...args
}: {
  [key: string]: string | number | boolean | undefined;
}) => {
  const properties: { [key: string]: string | number | boolean | undefined } = {};

  for (const key in args) {
    if (Object.prototype.hasOwnProperty.call(args, key)) {
      properties[key] = args[key];
    }
  }

  // Try to call gtag('set','user_properties', ...) if available, otherwise push to dataLayer
  const anyWindow = window as any;
  if (anyWindow && typeof anyWindow.gtag === "function") {
    try {
      anyWindow.gtag("set", "user_properties", properties);
      return;
    } catch (e) {
      // continue to fallback
    }
  }
  anyWindow?.dataLayer?.push({ event: "set_user_properties", user_properties: properties });
};
